import { render, staticRenderFns } from "./bookinglist.vue?vue&type=template&id=010e287e&"
import script from "./bookinglist.vue?vue&type=script&lang=js&"
export * from "./bookinglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports